import React from 'react'

const TableName = ({ table }) => {
  return (
    <div className={`w-full py-1.5 px-4 ${ table ? "bg-blue" : "bg-blue/40"} text-white font-semibold rounded-lg`} >Table No. {table}</div>
  )
}

export default TableName